import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "fluid", "unbordered"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Link from '../Link';
import Tooltip from '../Tooltip';
const Root = styled.div.withConfig({
  displayName: "NavbarSection__Root",
  componentId: "sc-1pheav5-0"
})(["align-items:center;border-left:1px solid var(--neutral-border);padding-right:var(--size-spacing-04);padding-left:var(--size-spacing-04);> *{margin-top:0;margin-bottom:0;}> ", "{display:flex;align-items:center;align-self:stretch;}", "{font-size:var(--text-size-sm);}", " ", ""], Tooltip.WrapperStyle, Link.Style, _ref => {
  let {
    $fluid
  } = _ref;
  return $fluid && css(["overflow-x:hidden;flex:1;width:0;"]);
}, _ref2 => {
  let {
    $unbordered
  } = _ref2;
  return $unbordered && css(["border-left:none;padding:0;"]);
});
const NavbarSection = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
      children,
      fluid,
      unbordered
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    $fluid: fluid,
    $unbordered: unbordered,
    ref: ref
  }), children);
});
NavbarSection.displayName = 'NavbarSection';
NavbarSection.Style = Root;
NavbarSection.defaultProps = {
  fluid: false,
  unbordered: false
};
process.env.NODE_ENV !== "production" ? NavbarSection.propTypes = {
  /**
   * Sets children.
   */
  children: PropTypes.node,
  /**
   * Makes the `Navbar.Section` fill all available horizontal space.
   */
  fluid: PropTypes.bool,
  /**
   * Removes the `Navbar.Section` border.
   */
  unbordered: PropTypes.bool
} : void 0;
export default NavbarSection;